import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DxSwitchModule, DxTagBoxModule } from 'devextreme-angular';
import { DxAccordionModule } from 'devextreme-angular';
import { DxButtonModule } from 'devextreme-angular';
import { DxButtonGroupModule } from 'devextreme-angular';
import { DxChartModule } from 'devextreme-angular';
import { DxCheckBoxModule } from 'devextreme-angular';
import { DxDataGridModule } from 'devextreme-angular';
import { DxDateBoxModule } from 'devextreme-angular';
import { DxDropDownBoxModule } from 'devextreme-angular';
import { DxDropDownButtonModule } from 'devextreme-angular';
import { DxFormModule } from 'devextreme-angular';
import { DxHtmlEditorModule } from 'devextreme-angular';
import { DxListModule } from 'devextreme-angular';
import { DxLoadIndicatorModule } from 'devextreme-angular';
import { DxLoadPanelModule } from 'devextreme-angular';
import { DxLookupModule } from 'devextreme-angular';
import { DxNumberBoxModule } from 'devextreme-angular';
import { DxPopoverModule } from 'devextreme-angular';
import { DxPopupModule } from 'devextreme-angular';
import { DxRadioGroupModule } from 'devextreme-angular';
import { DxScrollViewModule } from 'devextreme-angular';
import { DxSelectBoxModule } from 'devextreme-angular';
import { DxSpeedDialActionModule } from 'devextreme-angular';
import { DxTabPanelModule } from 'devextreme-angular';
import { DxTextAreaModule } from 'devextreme-angular';
import { DxTextBoxModule } from 'devextreme-angular';
import { DxToolbarModule } from 'devextreme-angular';
import { DxTooltipModule } from 'devextreme-angular';
import { DxTreeListModule } from 'devextreme-angular';
import { DxValidatorModule } from 'devextreme-angular';

import { SingleCardModule } from '../../shared/components/single-card/single-card.component';
import { SharedModule } from '../../shared/shared.module';
import { AdditionalCopiesComponent } from './components/additional-copies/additional-copies.component';
import { CancelDialogComponent } from './components/cancel-dialog/cancel-dialog.component';
import { ElectronicSignatureRadioButtonComponent } from './components/electronic-signature-radio-button/electronic-signature-radio-button.component';
import { RecentRequisitionsComponent } from './components/recent-requisitions/recent-requisitions.component';
import { RequisitionDoneDialogComponent } from './components/requisition-done-dialog/requisition-done-dialog.component';
import { RequisitionSearchContentComponent } from './components/requisition-search-content/requisition-search-content.component';
import { RequisitionStatusRadioButtonsComponent } from './components/requisition-status-radio-buttons/requisition-status-radio-buttons.component';
import { SignatureDialogComponent } from './components/signature-dialog/signature-dialog.component';
import { SignatureUnsingDialogComponent } from './components/signature-unsing-dialog/signature-unsing-dialog.component';
import { RequisitionCreateComponent } from './pages/requisition-create/requisition-create.component';
import { RequisitionSearchComponent } from './pages/requisition-search/requisition-search.component';

import { TestPickerComponent } from './components/test-picker/test-picker.component';
import { RequisitionsRoutingModule } from './requisitions-routing.module';

@NgModule({
    declarations: [
        SignatureDialogComponent,
        SignatureUnsingDialogComponent,
        RecentRequisitionsComponent,
        RequisitionDoneDialogComponent,
        RequisitionStatusRadioButtonsComponent,
        RequisitionCreateComponent,
        RequisitionSearchComponent,
        RequisitionSearchContentComponent,
        AdditionalCopiesComponent,
        CancelDialogComponent,
        ElectronicSignatureRadioButtonComponent,
        TestPickerComponent,
    ],
    imports: [
        CommonModule,
        FlexLayoutModule,
        FormsModule,
        ReactiveFormsModule,
        DxTextBoxModule,
        DxSelectBoxModule,
        DxValidatorModule,
        DxTreeListModule,
        DxPopupModule,
        DxDateBoxModule,
        DxHtmlEditorModule,
        DxButtonModule,
        DxTextAreaModule,
        DxAccordionModule,
        DxLookupModule,
        DxNumberBoxModule,
        DxChartModule,
        DxCheckBoxModule,
        DxTabPanelModule,
        DxFormModule,
        DxScrollViewModule,
        DxPopoverModule,
        DxListModule,
        DxTooltipModule,
        DxToolbarModule,
        DxLoadPanelModule,
        DxButtonGroupModule,
        DxLookupModule,
        DxSpeedDialActionModule,
        DxRadioGroupModule,
        DxDropDownButtonModule,
        DxDropDownBoxModule,
        DxLoadIndicatorModule,
        DxDataGridModule,
        DxTagBoxModule,
        DxSwitchModule,
        SharedModule,
        SingleCardModule,
        RequisitionsRoutingModule,
    ]
})
export class RequisitionsModule {
}
